import { Link } from 'react-router-dom';
import { tenantCan } from '@intelimove/contracts';
import { ROLE_LABEL, useAuth } from '../auth/AuthContext';
import { EmptyState } from '../components/States';
import { PageHead } from '../components/Widgets';
import { tenantAdminAdapter } from '../data/organizationAdmin';
import { useResource } from '../hooks/useResource';
import { ADMIN_BASE } from './OrganizationAdmin';

export function Settings() {
  const { me } = useAuth();
  const org = me?.activeOrganization;
  return (
    <section aria-labelledby="page-title">
      <PageHead eyebrow="Administração" title="Configurações" subtitle="Perfis, critérios de prioridade e preferências da organização." />
      <div className="settings-grid">
        <article className="card">
          <div className="card-head"><div><h2>Contexto da empresa</h2><div className="card-sub">Quem é a empresa, o que vende, para quem e onde</div></div></div>
          <p className="card-sub">Base de toda pesquisa de mercado: identidade, produtos e serviços, mercados, ICPs, personas, diferenciais, concorrentes conhecidos, objetivos, evidências e histórico de versões.</p>
          <div className="form-actions"><Link className="cta" to="/configuracoes/contexto/visao-geral">Abrir contexto da empresa</Link></div>
        </article>
        <article className="card">
          <div className="card-head"><div><h2>Integrações</h2><div className="card-sub">Opcional: a InteliMove funciona sem integração</div></div></div>
          <p className="card-sub">Conecte o CERES CRM para levar empresas-alvo, sinais e recomendações à operação comercial e acompanhar a saúde da sincronização.</p>
          <div className="form-actions"><Link className="cta" to="/configuracoes/integracoes">Abrir integrações</Link></div>
        </article>
        <article className="card">
          <div className="card-head"><div><h2>Organização ativa</h2><div className="card-sub">Os dados comerciais pertencem à organização e são compartilhados por todos os membros</div></div></div>
          <dl className="kv">
            <dt>Nome</dt><dd>{org?.name ?? '—'}</dd>
            <dt>Identificador</dt><dd>{org?.slug ?? '—'}</dd>
            <dt>Seu papel</dt><dd>{org ? ROLE_LABEL[org.role] : '—'}</dd>
            <dt>Usuário</dt><dd>{me?.user.email}</dd>
          </dl>
        </article>
        <AdministrationCard />
      </div>
      <EmptyState title="Critérios de prioridade" glyph="IM">
        Pesos de prioridade e preferências entram numa próxima rodada. Os ICPs já ficam em Contexto da empresa.
      </EmptyState>
    </section>
  );
}

// IM-UX-176 (IM-SAAS-003): usuários, convites, perfis, assinatura e histórico ficam em Administração da empresa.
function AdministrationCard() {
  const { me } = useAuth();
  const role = me?.activeOrganization?.role;
  const canSeeUsers = tenantCan(role, 'organization.members.read');
  const { state } = useResource((s) => (canSeeUsers ? tenantAdminAdapter.members({ limit: 1 }, s).then((r) => r.counts) : Promise.resolve(null)), [canSeeUsers]);
  const counts = state.kind === 'ready' ? state.data : null;
  return (
    <article className="card">
      <div className="card-head"><div><h2>Administração da empresa</h2><div className="card-sub">{canSeeUsers ? 'Usuários e acessos, convites, perfis, assinatura e histórico' : 'Dados da empresa e perfis de acesso'}</div></div></div>
      {counts && <dl className="kpi-row ta-kpis"><div><dt>Usuários ativos</dt><dd>{counts.active}</dd></div><div><dt>Inativos</dt><dd>{counts.inactive}</dd></div><div><dt>Convites pendentes</dt><dd>{counts.pendingInvitations}</dd></div></dl>}
      <div className="form-actions">
        {canSeeUsers && <Link className="cta" to={`${ADMIN_BASE}/usuarios`}>Gerenciar usuários</Link>}
        <Link className={canSeeUsers ? 'secondary btn-link' : 'cta'} to={`${ADMIN_BASE}/${canSeeUsers ? 'perfis' : 'empresa'}`}>{canSeeUsers ? 'Perfis e permissões' : 'Abrir administração da empresa'}</Link>
      </div>
    </article>
  );
}
